<script>

  export default {
    components: {},
    props: {
      planotrabalhos: {
        type: Array,
        required: true
      },
      aprovado: {
        type: Boolean,
        required: true,
        default: false,
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      },
      readonly: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      retornaNomeQuantidadeExecutada(index) {
        return 'quantidadeexecutada' + index;
      },
      retornaNomeObservacaoExecutada(index) {
        return 'observacaoexecutada' + index;
      },
      validaObservacao(planoTrabalho) {
        if (this.readonly)
          return '';

        let valor = this.$options.filters.formatarNumero(planoTrabalho.quantidadeExecutada, true);

        if (valor <= 0.01)
          return 'required';

        return '';
      },
    },
    computed: {
    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th></th>
            <th style="width:15%">Meta</th>
            <th style="width:15%">Etapa</th>
            <th>Atividade</th>
            <th>Unidade</th>
            <th style="width:10%">Data in&iacute;cio</th>
            <th style="width:10%">Data fim</th>
            <th>Quantidade prevista</th>
            <th>Quantidade executada</th>
            <th>Observa&ccedil;&atilde;o</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(planoTrabalho, index) in planotrabalhos">
            <td></td>
            <td>{{ planoTrabalho.projetoPlanoTrabalhoMeta ? planoTrabalho.projetoPlanoTrabalhoMeta.nomeProjetoPlanoTrabalhoMeta : '---' }}</td>
            <td>{{ planoTrabalho.etapa || '---' }}</td>
            <td>{{ planoTrabalho.atividade || '---' }}</td>
            <td>{{ planoTrabalho.unidade || '---' }}</td>
            <td>{{ planoTrabalho.dataInicioExecucao | formatarData }}</td>
            <td>{{ planoTrabalho.dataFinalExecucao | formatarData }}</td>
            <td>{{ planoTrabalho.quantidadePrevista | formatarNumero }}</td>
            <td style="width:12%" v-if="!aprovado">
              <input type="text"
                     class="form-control text-right"
                     :id="retornaNomeQuantidadeExecutada(index)"
                     v-mascara="'moeda'"
                     v-model="planoTrabalho.quantidadeExecutada"
                     :data-vv-name="retornaNomeQuantidadeExecutada(index)"
                     :readonly="readonly"
                     data-vv-as="quantidade executada">
            </td>
            <td style="width:12%" v-else>{{ planoTrabalho.quantidadeExecutada | formatarNumero }}</td>
            <td style="width:20%" v-if="!aprovado">
              <input type="text"
                     class="form-control text-left"
                     :id="retornaNomeObservacaoExecutada(index)"
                     v-model="planoTrabalho.observacao"
                     :data-vv-name="retornaNomeObservacaoExecutada(index)"
                     :readonly="readonly"
                     v-validate="validaObservacao(planoTrabalho)"
                     data-vv-as="observacao">
            </td>
            <td style="width: 20%" v-else>{{ planoTrabalho.observacao || '---' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/compartilhado/FormPlanoTrabalho.vue